import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const NotesButton = ({ isMobile }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [notes, setNotes] = useState('');

  const toggleNotes = () => {
    setIsOpen(!isOpen);
  };

  const handleNotesChange = (e) => {
    setNotes(e.target.value);
    localStorage.setItem('userNotes', e.target.value);
  };

  // Load notes from localStorage and listen for updates
  useEffect(() => {
    const loadNotes = () => {
      const savedNotes = localStorage.getItem('userNotes');
      if (savedNotes) {
        setNotes(savedNotes);
      }
    };

    loadNotes();
    window.addEventListener('notesUpdated', loadNotes);
    
    return () => {
      window.removeEventListener('notesUpdated', loadNotes);
    };
  }, []);

  return (
    <>
      <button
        onClick={toggleNotes}
        style={{
          position: 'fixed',
          right: isMobile ? '20px' : '40px',
          bottom: '20px',
          backgroundColor: '#1a1a1a',
          color: '#fff',
          border: '1px solid #333',
          borderRadius: '8px',
          padding: '8px 16px',
          cursor: 'pointer',
          fontFamily: "'Poppins', sans-serif",
          fontSize: '14px',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          transition: 'all 0.2s ease',
        }}
      >
        📝 Notes {notes && ' •'}
      </button>

      {isOpen && (
        <div
          style={{
            position: 'fixed',
            right: isMobile ? '20px' : '40px',
            bottom: '80px',
            width: isMobile ? 'calc(100% - 80px)' : '400px',
            backgroundColor: '#1a1a1a',
            border: '1px solid #333',
            borderRadius: '12px',
            padding: '16px',
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
          }}
        >
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '12px'
          }}>
            <h3 style={{
              margin: 0,
              color: '#fff',
              fontFamily: "'Poppins', sans-serif",
              fontSize: '16px'
            }}>
              Your Notes
            </h3>
            <button
              onClick={toggleNotes}
              style={{
                background: 'none',
                border: 'none',
                color: '#666',
                cursor: 'pointer',
                padding: '4px',
              }}
            >
              <X size={20} />
            </button>
          </div>
          <textarea
            value={notes}
            onChange={handleNotesChange}
            placeholder="Highlight text from content to take notes!"
            style={{
              width: '90%',
              height: isMobile? '200px' : '350px',
              backgroundColor: '#141414',
              border: '1px solid #333',
              borderRadius: '8px',
              padding: '12px',
              color: '#fff',
              fontFamily: "'Poppins', sans-serif",
              fontSize: '14px',
              resize: 'vertical',
              outline: 'none',
            }}
          />
        </div>
      )}
    </>
  );
};

export default NotesButton;